const order = resolve =>
  require(["@/components/transacts/order/index.vue"], resolve);
const order_details = resolve =>
  require(["@/components/transacts/order/order_details.vue"], resolve);
const order_invoice = resolve =>
  require(["@/components/transacts/order/order_invoice.vue"], resolve);
const appraise = resolve =>
  require(["@/components/transacts/appraise/index.vue"], resolve);
const returngoods = resolve =>
  require(["@/components/transacts/returngoods/index.vue"], resolve);
const returngoods_detail = resolve =>
  require([
    "@/components/transacts/returngoods/returngoods_detail.vue"
  ], resolve);
export default [
  {
    path: "/homeMain/transacts/order",
    component: order,
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/homeMain/transacts/order_details",
    component: order_details
  },
  {
    path: "/homeMain/transacts/order_invoice",
    component: order_invoice
  },
  {
    path: "/homeMain/transacts/appraise",
    component: appraise,
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/homeMain/transacts/returngoods",
    component: returngoods,
    meta: {
      keepAlive: true
    }
  },

  {
    path: "/homeMain/transacts/returngoods_detail",
    component: returngoods_detail
  }
];



// WEBPACK FOOTER //
// ./src/router/transacts.js